import { Dayjs } from 'dayjs'
import { CalculatedVisitStatus, EncounterStatus } from 'fhir/Encounter/constants'
import { AppointmentType } from 'fhir/Appointment/constants'
import { ServiceTypeName } from 'fhir/HealthcareService/constants'
import { Participant } from './helpers/processAppointments'
export interface SelectedEvent {
  participants: Participant[]
  visitType: AppointmentType
  serviceType?: ServiceTypeName
  appointmentId: string
  encounterId?: string
  visitQaTaskId?: string
  cnaVisitTaskIds?: string[]
  status: CalculatedVisitStatus
  encounterStatus?: EncounterStatus
  appointmentStatus?: string
  start: Dayjs
  end: Dayjs
  notes: string
  reasonForChange?: string
}

export enum AppointmentActor {
  PRACTITIONER = 'practitioner',
  PATIENT = 'patient'
}

export type ScheduleFormType = {
  appointmentTime: Date[]
  caregiverRef: string
  visitStatus: CalculatedVisitStatus
  throughDate: Dayjs | null
  changeReason?: string
  notes: string
}
